export const historyMarketResult = (numbers, forPopUp = false) => {
  return numbers.reduce((acc, current, index, arr) => {
    let result = `${acc}${current.from}`;
    if (current.to === current.from) {
      result += '';
    } else {
      result += '-';
    }

    if (current.to === current.from) {
      result += '';
    } else {
      result += current.to;
    }

    if (index + 1 !== arr.length) {
      if (forPopUp) {
        result += '\n';
      } else {
        result += ', ';
      }
    } else {
      result += '';
    }
    return result;
  }, '');
};
